import { CardHighlight04Styles } from './CardHighlight04.styled';

export const CardHighlight04: React.FC<
  React.ComponentPropsWithoutRef<'div'>
> = ({ children, ...rest }) => {
  return (
    <CardHighlight04Styles.Root {...rest}>
      {children}
    </CardHighlight04Styles.Root>
  );
};
